import { render, staticRenderFns } from "./AbscessScarringPericarditisComponent.vue?vue&type=template&id=f3544e32&"
import script from "./AbscessScarringPericarditisComponent.vue?vue&type=script&lang=ts&"
export * from "./AbscessScarringPericarditisComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports